import { fetchRelay } from '../relay-env';
import type { HsSyncUserTokenInput } from '../types';

export const hubspotUserTokenSyncMutationCompat = async (input: HsSyncUserTokenInput) => {
  const response = await fetchRelay(
    {
      name: 'TelemetrySync_HubspotUserToken_Mutation',
      text: `
        mutation TelemetrySync_HubspotUserToken_Mutation($input: HsSyncUserTokenInput!) {
          hsSyncUserToken(input: $input) {
            status
          }
        }
    `,
      cacheID: `hubspotUserTokenSyncMutationCompat_${JSON.stringify(input)}_${crypto.randomUUID()}`,
      id: null,
      metadata: {},
      operationKind: 'mutation',
    },
    // biome-ignore lint: @todo - biome refactor
    { input } as any
  );

  return response;
};
